'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

///<reference path="../../../typings/tsd.d.ts" />
var agencyRegistration;
(function (agencyRegistration) {
    var factory;
    (function (factory) {
        var AgentModel = function AgentModel() {
            _classCallCheck(this, AgentModel);

            this.data = {
                cnpj: undefined,
                partners: [{ personType: 'F' }],
                address: { countryCode: 'BR', stateCode: "SP" },
                companyData: { phones: [{ type: 'T' }] },
                bankData: {}
            };
        };

        var agentFactory = function () {
            /*@ngInject*/

            function agentFactory() {
                _classCallCheck(this, agentFactory);

                this.agency = new AgentModel().data;
            }

            _createClass(agentFactory, [{
                key: 'getAgency',
                value: function getAgency() {
                    return this.agency;
                }
            }, {
                key: 'setNewAgency',
                value: function setNewAgency() {
                    this.agency = $.extend(this.agency, new AgentModel().data);
                }
            }]);

            return agentFactory;
        }();

        factory.agentFactory = agentFactory;
    })(factory = agencyRegistration.factory || (agencyRegistration.factory = {}));
})(agencyRegistration || (agencyRegistration = {}));
angular.module('agencyRegistrationApp').factory('agentFactory', function () {
    return new agencyRegistration.factory.agentFactory();
});